import React, {useCallback, useEffect, useState} from 'react'
import {CardContent, CardHeader, Grid} from "@mui/material";
import {Breadcrumbs} from "../../../../Components";
import {useDispatch, useSelector} from "react-redux";
import {AddUser, fetchUsers, MainTable} from '../index';
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {setRightDrawer} from "../../../Common/App";
import useDeepEqualSelector from "../../../../Hooks/useDeepEqualSelector";
import {TableActions} from "./Menus/TableActions";
import {TableCard} from "../../../../Components";

export const Users = () => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const filters = useSelector((store) => store.users?.config?.filters);
    const pagination = useDeepEqualSelector((store) => store.users.config.pagination);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        const columns = ['id', 'first_name', 'last_name', 'email', 'department_id', 'avatar', 'role_type','last_login_at', 'created_at','mobile','username','deleted_at','is_registration_completed','is_super_admin'];
        await fetchUsers({dispatch, filters:{...filters, ...pagination, columns, with:['roles','department']}}).then((res)=>{
            setIsLoading(false);
        });
    },[filters, pagination, dispatch]);

    useEffect(() => {
        fetchData();
    },[fetchData]);

    const addItem = useCallback(async () => {
        dispatch(setRightDrawer({component: <AddUser />, open: true}));
    }, [dispatch]);

    return (
        <Grid container spacing={3} elevated={3}>
            <Grid item xs={12}>
                <Box justifyContent={"space-between"} display={"flex"}>
                    <Breadcrumbs items={['DASHBOARD','USER']} />
                    <Button variant="contained" onClick={addItem}>Add User</Button>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <TableCard>
                    <CardHeader
                        title={"Users"}
                        action={<TableActions />}
                    />
                    <CardContent>
                        <MainTable isLoading={isLoading} setIsLoading={setIsLoading} />
                    </CardContent>
                </TableCard>
            </Grid>
        </Grid>
    );
}
